import apiUrl from '@/common/apiUrl'
import webApiUtil from '@/common/webApiUtil'

export default {
  namespaced: true,
  state: {
    dataAllList: {
      totalRows: 0,
      list: []
    }
  },
  mutations: {
    setResultDataList: (state, data) => {
      state.dataAllList.list = data.dataList
      state.dataAllList.totalRows = data.dataList ? data.dataList.length : 0
    }
  },
  getters: {},
  actions: {
    initDataList: ({commit}) => {
      commit('setResultDataList', {dataList: []})
    },
    getDataList: async ({commit}, _params = {}) => {
      let resData = {}
      try {
        const url = apiUrl.other.estateType.list
        const res = await webApiUtil.post(url, _params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          resData['dataList'] = res.data['types'] || []
        } else {
          resData['dataList'] = []
        }
      } catch (e) {
        resData['dataList'] = []
      }

      commit('setResultDataList', resData)
    },
    createDataOther: async ({rootState}, _params = {}) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.other.estateType.create
        const res = await webApiUtil.post(url, _params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return 'createDataOtherSuccess'
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
    updateDataOther: async ({rootState}, _params = {}) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.other.estateType.update
        const res = await webApiUtil.post(url, _params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return 'updateDataOtherSuccess'
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
    deleteDataOther: async ({rootState}, _params = []) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.other.estateType.delete
        let params = {
          delete_ids: _params
        }
        const res = await webApiUtil.post(url, params)

        if (res && res.data) {
          if (res.data.status === 0 && res.data.message !== 'No Data') {
            return 'deleteDataOtherSuccess'
          } else {
            return res
          }
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    }
  }
}
